import { ColumnTypes } from '@app/library/states/columns.actions';

const tag = '[TrashColumns]';

export class ToggleTrashColumn {
  static readonly type = `${tag} toggle trash column showing`;
  constructor(public column: ColumnTypes) {}
}

export class SetMobileTrashColumns {
  static readonly type = `${tag} set mobile default trash columns`;
}
